import { clsx } from 'clsx';
import type { StateBadgeProps } from './MasterDocument.types';

/**
 * StateBadge — insignia visual que muestra el estado actual de un documento.
 *
 * Renderiza una etiqueta con colores personalizados (fondo y texto) definidos
 * por la máquina de estados del template. En modo oscuro aplica un filtro
 * de brillo/saturación para mantener la legibilidad.
 *
 * @see MasterDocument.types — `StateBadgeProps` para la definición de colores
 *
 * @example
 * ```tsx
 * <StateBadge label="Aprobado" bg="#d1fae5" color="#065f46" />
 * ```
 */
export function StateBadge({ label, bg, color, className }: StateBadgeProps) {
  return (
    <span
      role="status"
      className={clsx(
        // Geometría del canon de MasterCrud (ADR-027 §E): medida el 2026-09-04 sobre
        // /app/items — 20px de alto, 12px/500, radio 4px, padding 2/8, interlineado 16px.
        // Antes era una píldora 22px 12px/600 con padding 3/10, que junto a un badge de
        // MasterCrud se leía como otro producto.
        'inline-flex items-center px-2 py-0.5 rounded text-xs leading-4 font-medium transition-colors duration-200 select-none',
        'dark:[filter:brightness(0.85)_saturate(1.2)]',
        className,
      )}
      style={{ backgroundColor: bg, color }}
    >
      {label}
    </span>
  );
}
